<template>
    <div class="collection">
        <div class="collectNav">
            <!-- <nuxt-link to="/collect"   class="navList">电子书</nuxt-link>-->
            <!--   <nuxt-link to="/personal/collection/videoCollect"   class="navList">视频</nuxt-link>-->
        </div>
        <div class="content">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import {store} from '../../../store/store.js';

    export default {
        name: "collection",
        data() {
            return {}
        },
        mounted() {
            store.personal._this.activeNav = "我的收藏";
        },
    }
</script>

<style scoped lang="sass">
    .collection
        width: 100%
        height: 100%
        padding: 25px 28px
        box-sizing: border-box
        .collectNav
            border-bottom: 1px solid #ececec
            padding-bottom: 12px
        .navList
            color: #333333
            font-size: 16px
            ine-height: 12px
            margin-right: 30px
            position: relative
            cursor: pointer
        .nuxt-link-exact-active
            color: #cb7629
            &::after
                border: 1px solid #cb7629
                content: ''
                display: block
                position: absolute
                bottom: -13px
                left: 0
                width: 100%
</style>
